// extracted by mini-css-extract-plugin
export default {"selector":"CurrencySelector_selector__Uy5ag","label":"CurrencySelector_label__Ve-5o"};